import { useId, useState } from 'react';
import { launchUrl } from '../api';

export function LaunchChoice() {
  const [remember, setRemember] = useState(false);
  const id = useId();
  return (
    <section className="choice" aria-labelledby={`${id}-t`}>
      <h2 id={`${id}-t`}>Où souhaitez-vous ouvrir WH ?</h2>
      <p className="muted">Vos instances cloud et locale sont toutes deux disponibles.</p>
      <div className="choice-buttons">
        <a className="btn btn-big btn-primary" href={launchUrl('cloud', remember)}>
          <span aria-hidden="true">☁️</span> Ouvrir le cloud
        </a>
        <a className="btn btn-big btn-primary" href={launchUrl('local', remember)}>
          <span aria-hidden="true">💻</span> Ouvrir en local
        </a>
      </div>
      <label className="check">
        <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
        Se souvenir de mon choix
      </label>
    </section>
  );
}
